var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',{staticClass:"mb-5",attrs:{"title":"Lab","step-component":'BillingStep'}},[(_vm.lab_id)?_c('div',{staticClass:"review"},[_vm._v(" Lab Name: "),_c('span',[_vm._v(_vm._s((_vm.getById("labs", _vm.lab_id) || {}).title || "N/A"))]),_c('br'),_vm._v(" Lab ID: "),_c('span',[_vm._v(_vm._s(_vm.lab_id))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }